module.exports = __webpack_public_path__ + "static/media/item__food-3.e77f0f44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/dinerGame/item__food-3.png
// module id = 2328
// module chunks = 0